module.exports = "/images/BA.png?0cea51fa999ccdc4ddd74c736a586e13";